import styled from "styled-components";

export const LeftContainer = styled.div`
  display: flex;
  width: 1200px;
  justify-content: space-between;
`;
